{
  "file_preview": {
    "confirm_delete_content": "Click confirm to delete {{filename}}",
    "delete_aria_label": "delete {{filename}}"
  },
  "upload_file": {
    "drag_or_click": "Drag a single document here or click to upload (max file size: {{maxFileSize}} MB)",
    "uploading": "Uploading, this might take a minute...",
    "max_file_size_error": "Max file size: {{max}}MB, current file size: {{current}}MB",
    "unsupported_file_type_error": "Unsupported file type: {{type}}"
  },
  "form": {
    "validation": {
      "url_or_file_required": "Please enter an url or upload the document"
    },
    "labels": {
      "document_name": "Document Name",
      "document_url": "Document URL"
    },
    "or": "or"
  },
  "actions": {
    "document": "Document"
  },
  "modal": {
    "add_document": "Add Document"
  },
  "fallback": {
    "default_filename": "Doc"
  }
}
